module.exports = __webpack_public_path__ + "img/reflesh-gray.07910eee.svg";